import React from 'react'
import clsx from 'clsx'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ticketTone } from '../helpers'

const TicketChip = ({ ticket }) => (
  <a
    href={ticket.url}
    target="_blank"
    rel="noopener noreferrer"
    title={ticket.title}
    onClick={(e) => e.stopPropagation()}
    className={clsx('tw-chip no-underline hover:no-underline hover:opacity-80', ticketTone(ticket.status))}
  >
    <FontAwesomeIcon icon="headset" className="text-[9px] opacity-70" />
    Ticket #{ticket.id} · {ticket.status_label}
  </a>
)

export default TicketChip
